import React from 'react'
import createReactClass from 'create-react-class'


var PaginatorPageLink = createReactClass({
	getInitialState: function () {
		return {};
	},
	clickPage: function () {
		this.props.callback(this.props.page);
	},
	render: function() {
		if (this.props.selected) {
			return (
				<div onClick={this.clickPage} className="ope-paginator__page ope-paginator__page__selected">{this.props.page}</div>
			);
		} else {
			return (
				<div onClick={this.clickPage} className="ope-paginator__page">{this.props.page}</div>
			);
		}

	}
});

export default PaginatorPageLink;
